import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useRenewalsStore} from "../../store/renewals.store";

export const useRenewalsByQuarter = () => {
    const setRenewalsByQuarter = useRenewalsStore((state) => state.setRenewalsByQuarter);

    return useMutation(PartnerApi.renewalListByQuarter, {
        onSuccess: (data) => {
            setRenewalsByQuarter(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};

export const useRenewalsByCustomer = () => {
    const setRenewalsByCustomer = useRenewalsStore((state) => state.setRenewalsByCustomer);

    return useMutation(PartnerApi.renewalListByCustomer, {
        onSuccess: (data) => {
            setRenewalsByCustomer(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};

export const useRenewalsCustomers = () => {
    const setCustomers = useRenewalsStore((state) => state.setCustomers);

    return useMutation(PartnerApi.renewalListCustomers, {
        onSuccess: (data) => {
            setCustomers(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};

export const useRenewalOffer = () => {
    const setRenewalOffer = useRenewalsStore((state) => state.setRenewalOffer);

    return useMutation(PartnerApi.renewalOffer, {
        onSuccess: (data) => {
            setRenewalOffer(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};